import * as React from "react";
import {useContext, useState} from "react";
import {DefaultButton, Panel, PrimaryButton, Stack} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";
import {dbDate} from "../../Utilities/dbDate";
import DatePickerPL from "../../Components/DatePickerPL";

function FinishVentureAgreement(props) {
    const [user] = useContext(AuthContext);
    const [date, setDate] = useState(new Date())

    const _submit = (e) => {
        e.preventDefault();
        const data = {
            done: dbDate(date),
        };
        fetch(`/api/venture/agreement/${props.finish.id}/finish`, {
            method: "PUT",
            body: JSON.stringify(data),
            headers: {
                "Authorization": "Bearer " + user.token,
            },
        }).then(res => res.json())
            .then(json => {
                props.onSuccess(json);
                props.dismissPanel();
            })
            .catch(err => {
                console.log(err);
            });
    };

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign="space-between">
        <PrimaryButton type="submit" form="FinishVentureAgreement">Zrealizowano</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);

    return (
        <Panel
            isOpen={props.finish}
            onDismiss={() => {props.dismissPanel(); setDate(new Date())}}
            headerText={"Realizacja umowy " + props.finish.name}
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id="FinishVentureAgreement">
                <DatePickerPL
                    label="Data realizacji"
                    isRequired={true}
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={date}
                    onSelectDate={(e) => setDate(e || '')}
                    autofocus
                />
            </form>

        </Panel>
    )
}

export default FinishVentureAgreement